import { DAILY_API_URL } from "./constants";

export const getDailyMeetingUrl = ({ meetingId }: { meetingId: string }) =>
  `${DAILY_API_URL}/${meetingId}`;
